<template>
  <s-modal @close="$emit('close')" no-body-padding>
    <h3 slot="header">
      {{$t("order_header")}}
    </h3>
    <div slot="body" class="modal-body">
      <div class="order">
        <hr>
        {{ store.name }}
        <hr>
        {{ order.customerName }}<br>
        <template v-if="order.customerEmail">{{ order.customerEmail }}<br></template>
        <template v-if="order.customerPhone">{{ order.customerPhone }}<br></template>
        <template v-for="item in order.items">
          <hr>
          {{ item.quantity }}x {{ item.productName }}<br>
          <template v-for="choice in item.choices">
            <template v-if="choice.type === 'OPTIONS_SINGLE_CHOICE'">
              {{ choice.title }}: {{ choice.singleChoiceAnswer }}<br>
            </template>
            <template v-else-if="choice.type === 'OPTIONS_MULTIPLE_CHOICE'">
              {{ choice.title }}: {{ choice.multipleChoiceAnswers.join(', ') }}<br>
            </template>
            <template v-else-if="choice.type === 'OPTIONS_REPEATABLE_CHOICE'">
              {{ choice.title }}: {{ choice.repeatableChoiceAnswers.map(a => `${a.quantity}x ${a.description}`).join(', ') }}<br>
            </template>
            <template v-else-if="choice.type === 'TEXT'">
              {{ choice.title }}: {{ choice.textAnswer }}<br>
            </template>
          </template>
          {{ item.price | formatCurrency }}<br>
        </template>
        <hr>
        Qtd. itens: {{ order.items | sumItems }}<br>
        <br>
        <template v-if="order.feesToBeNegotiated">
          Taxas a serem negociadas<br>
        </template>
        Subtotal: {{ order.subTotal | formatCurrency }}<br>
        <template v-if="!order.feesToBeNegotiated">
          Taxa de entrega: {{ order.deliveryFee | formatCurrency }}<br>
        </template>
        <template v-if="order.paymentMethodFee">
          {{ order.paymentMethodFee > 0 ? "Taxa pagamento" : "Desconto" }}: {{ order.paymentMethodFee | formatCurrency }}<br>
        </template>
        <template v-if="!order.feesToBeNegotiated">
          Total: {{ order.total | formatCurrency }}<br>
        </template>
        <template v-if="order.paymentMethod">
          <hr>
          Pagamento: {{ order.paymentMethod }}<br>
          <template v-if="order.paymentChangeFor">
            Troco p/ {{ order.paymentChangeFor | formatCurrency }}
            <template v-if="!order.feesToBeNegotiated">
              &nbsp;({{ paymentChange | formatCurrency }})
            </template>
            <br>
          </template>
        </template>
        <template v-if="order.type === 'DELIVERY'">
          <hr>
          ENDEREÇO PARA DELIVERY<br>
          {{ order.deliveryAddress.line1 }}<br>
          Número: {{ order.deliveryAddress.houseNumber }}<br>
          <template v-if="order.deliveryAddress.line2">Complemento: {{ order.deliveryAddress.line2 }}<br></template>
          Bairro: {{ order.deliveryAddress.level3 }}<br>
          <template v-if="order.deliveryAddress.instructions">Referência: {{ order.deliveryAddress.instructions }}<br></template>
        </template>
        <template v-if="order.type === 'PICKUP'">
          <hr>
          RETIRADA NO LOCAL<br>
        </template>
        <hr>
        Sequencial: {{ order.sequentialNumber }}<br>
        Horário: {{ order.createdAt | formatDateTime }}<br>
        <br>
        Chave de identificação: {{ order.id }}<br>
      </div>
    </div>
  </s-modal>
</template>

<style scoped>
.modal-body {
  background: #111;
  padding: 14px;
  display: flex;
  justify-content: center;
}
.order {
  background: #fff;
  padding: 5px 15px 15px;
  max-width: 350px;
  font-size: 14px;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  overflow-wrap: anywhere;
}
</style>

<script>
import moment from "moment";
import SModal from "@/components/general/SModal.vue";

export default {
  name: 'OrderModal',
  i18nOptions: {namespaces: ['order_listing']},
  components: {SModal},
  props: {
    store: {
      type: Object,
      required: true,
      default() {
        return {
          name: ''
        }
      }
    },
    order: {
      type: Object,
      required: true,
      default() {
        return {
          customer: {
            name: '',
            email: undefined,
            phone: undefined
          },
          deliveryAddress: {
            line1: '',
            houseNumber: '',
            line2: '',
            level3: '',
            instructions: ''
          },
          payment: {
            method: '',
            changeFor: 0,
            withoutChange: false
          },
          shoppingCart: {
            items: [],
            feesToBeNegotiated: false,
            subTotal: 0,
            deliveryFee: 0,
            total: 0
          }
        }
      }
    },
  },
  filters: {
    formatDateTime: function (date) {
      return moment(date).format("lll")
    },
    formatCurrency: function (number) {
      return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(number)
    },
    sumItems: function (items) {
      return items.reduce((sum, item) => sum + item.quantity, 0)
    }
  },
  computed: {
    paymentChange() {
      return this.order.paymentChangeFor - this.order.total
    }
  },
  methods: {
    toText() {
      return this.$el.textContent.trim()
          .replace(/\n/g, '')
          .replace(/{br}/g, '\n')
    },
    toTextRaw() {
      return this.$el.textContent
    }
  }
}
</script>
